import React, { FC } from 'react';
import { GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import {
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  CTA_NAMES,
  buildPayloadUrl,
} from '@/utils/rudderstack';
import { getCtaTextStyles } from '@/components/utils';

export type AccountSettingsTileProps = {
  tile: TypeAccountNavTileFields;
};

const AccountSettingsTile: FC<AccountSettingsTileProps> = ({ tile }) => {
  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields),
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.ACCOUNT_SETTINGS_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        <UniversalLink
          link={tile.buttonLink}
          classes={`w-fit underline font-bold ${getCtaTextStyles()}`}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(AccountSettingsTile);
